import React from "react"
import { Link, graphql } from "gatsby"
import styled from "styled-components"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Notice from "../components/notice"

import { Banner } from "../components/organisms/banner"
import { ButtonLink } from "../components/atoms/buttons"
import { Grid } from "../components/atoms/grid"
import { Countdown } from "../components/molecules/countdown"
import Carousel from "../components/molecules/carousel"
import { NewsbyteCluster } from "../components/organisms/newsbyte"
import { SignUpdates } from "../components/forms"
import { FormCluster } from "../components/organisms/forms"

import { Settings } from "../styles/theme"

import SiteContext from "../context/SiteContext"

import { Statistics } from "../components/organisms/statistics"
import Video from "../video/video.mp4"

import { SimpleMasonry } from "../components/organisms/patterns"

import { Advertisement } from "../components/organisms/advertisement"

export const dataset = [
  {
    title: "CONFERENCE AND FORUMS",
    slug: "/trade/conferences-and-forums",
    description:
      "Engage with industry experts through thought-provoking sessions discussing the latest industry topics.",
  },
  {
    title: "INSPIRING AVIATORS OF TOMORROW",
    slug: "/trade/inspiring-aviators-of-tomorrow",
    description:
      "Explore the programmes and opportunities for the next generation of aviation talent.",
  },
  {
    title: "FLYING DISPLAYS",
    slug: "/trade/flying-displays",
    description:
      "Check out the spectacular line-up of aerial performances.",
  },
  {
    title: "WHAT'S NEXT @ SINGAPORE AIRSHOW",
    slug: "/trade/whats-next",
    description:
      "Catch nascent start-ups present and pitch their revolutionary technologies.",
  },
  {
    title: "STATIC DISPLAYS",
    slug: "/trade/static-displays",
    description:
      "Featuring the latest aircraft on display.",
  },
]

const HeroBanner = styled.div`
  h1,
  p,
  div {
    text-align: center;
  }
  .bannerContent {
    .gatsby-image-wrapper {
      min-height: 0;
      width: 100vw !important;
      position: relative !important;
      img {
        width: 100vw !important;
        min-height: 0;
      }
    }
    p {
      font-size: 0.9rem;
    }
    h1 {
      font-weight: 700;
      font-size: 2rem;
      line-height: 8rem;
      opacity: 0.8;
      letter-spacing: 0.1rem;
      padding-bottom: 0;
      margin: 0;
      @media screen and (max-width: 1040px) {
        font-size: 2rem;
        line-height: 2rem;
      }
      b {
        font-weight: 700;
      }
    }
  }
  video {
    height: 100%;
  }
  > div {
    padding-top: 10.5rem;
  }
`

const IndexForm = styled.div`
  background: #fafafa;
  overflow: hidden;
  height: 100%;
  h4 {
    margin-left: 2.5rem;
  }
  .flavor {
    color: #fff !important;
    font-size: 3rem;
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 999;
    top: 50%;
    transform: translateY(-100%);
  }
  input {
    border: none;
    background: #eaeaea;
  }
  .gatsby-image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100% !important;
  }
  > div {
    align-items: stretch;
  }
  .formElements {
    .constraint {
      > div {
        &:last-of-type {
          padding: 2rem 0 1rem;
        }
      }
    }
  }
`

const Commendation = styled.div`
  position: relative;
  > .gatsby-image-wrapper {
    position: absolute !important;
  }
  h2 {
    text-align: center;
    color: ${Settings.primaryColor};
  }
  > .constraint {
    padding: 5rem 0;
  }
  .active {
    padding: 0 5rem;
    @media screen and (min-width: ${Settings.sizeM}) {
      height: 15rem;
    }
    @media screen and (max-width: ${Settings.sizeM}) {
      height: 25rem;
      padding: 0 2.3rem;
    }
  }
  h3,
  h4 {
    margin: 0;
  }
`

const Partners = styled.div`
  position: relative;
  padding: 4rem 0;
  h2 {
    text-align: center;
    color: ${Settings.primaryColor};
  }
  > .constraint {
    padding: 0 0 5rem;
  }
  .active {
    > div {
      margin: 0 5px;
    }
  }
  h3,
  h4 {
    margin: 0;
  }
  > div {
    > div {
      height: 23rem;
      @media screen and (max-width: ${Settings.sizeM}) {
        height: 15rem;
      }
      align-items: center;
      justify-content: center;
      > div {
        flex: 0 0 25%;
      }
    }
  }
`

const Pagewide = styled.div`
  h2 {
    font-size: 2rem;
  }
  .button-wrap {
    > div {
      align-items: stretch;
      a,
      p,
      button {
        height: 100%;
      }
      p {
        margin: 0;
      }
    }
  }
`

class TradePage extends React.Component {
  componentDidMount() {
    this.context.setTrade(true)
  }
  render() {
    return (
      <Layout>
        <Pagewide>
          <SEO title="Home" />
          <HeroBanner>
            <Banner fluid={this.props.data.heroImage.childImageSharp.fluid}>
              <div className="content bannerContent"></div>
            </Banner>
          </HeroBanner>
          <div>
          <div className="constraint" style={{ maxWidth: "740px" }}>
            <h2 style={{textAlign: "center", color: "#195998", margin: "0", padding: "1rem 1rem 2rem"}}>2020 BY THE NUMBERS</h2>
            <Statistics />
          </div>

            {/* 
            <div
              className="constraint"
              style={{ maxWidth: "640px", padding: "0 0 4rem" }}
            >
              <div>
                <h4
                  style={{
                    color: "#707070",
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1.5rem",
                  }}
                >
                  Be part of the next edition!
                </h4>
                <div className="button-wrap">
                  <Grid columns={2} unstack>
                    <div style={{ textAlign: "center" }}>
                      <ButtonLink
                        text={"PARTICIPATION OPTIONS"}
                        slug={"/trade/participation-options"}
                        type={"solid"}
                      />
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <ButtonLink
                        text={"REGISTER TO ATTEND"}
                        external
                        slug={"https://app.singaporeairshow.com/"}
                        type={"solid"}
                        track={"DC-6953330/sgair0/fronc002+per_session"}
                      />
                    </div>
                  </Grid>
                </div>
              </div>
            </div>
            <Img
              fluid={this.props.data.bg1.childImageSharp.fluid}
              style={{
                zIndex: "-1",
              }}
            />
            */}
          </div>
          <Commendation>
            <Img
              fluid={this.props.data.commendation.childImageSharp.fluid}
              style={{
                zIndex: "-1",
                height: "100%",
                width: "100%",
              }}
            />
            <div className="constraint">
              <h2 style={{ textAlign: "center" }}>
                STRONG COMMENDATIONS FROM EXHIBITORS
              </h2>
              <div style={{ padding: "2rem 0 3rem" }} className="carousel">
                <Carousel slide={1}>
                  <div>
                    <h3>Zang Thio</h3>
                    <h4>
                    Senior Director Corporate Sales, Southeast Asia and Indian Subcontinent, Lufthansa Technik AG
                    </h4>
                    <p>
                    The Singapore Airshow is a fantastic platform for us to engage our customers. Most industry players would congregate here and it is great to have one event where we can meet all our customers. This year was no different - as we managed to have fruitful discussions with those who turned up despite the COVID-19 situation. The key industry players are all exhibiting and participating at this largest airshow in the fastest growing market - APAC - and that is why Lufthansa Technik commits to be here as well.
                    </p>
                  </div>
                  <div>
                    <h3>Skip Boyce</h3>
                    <h4>
                    President, Boeing Southeast Asia
                    </h4>
                    <p>
                    Asia is the largest growing aerospace market in the world and the trend line is firm and positive going into the future. Singapore Airshow is the greatest platform in Asia in bringing the aerospace community together – there’s no question about it. We really appreciate the target-rich environment that Singapore Airshow presents.
                    </p>
                  </div>
                  <div>
                    <h3>John Gosal</h3>
                    <h4>
                    Deputy Director, Aerospace, Global Affairs Canada
                    </h4>
                    <p>
                    Singapore airshow is one of the iconic airshows around the world that everybody knows about and it is really that one where you get that Asian perspective. We are here to expose the Canadian companies to the Asian market, and have developed some really good leads and introduced the Canadian companies to new potential customers. It is all about developing those networks and contacts, and from that stand point, it has been a fantastic show.
                    </p>
                  </div>
                </Carousel>
              </div>
              <div className="button-wrap">
                <Grid columns={2} unstack>
                  <div style={{ textAlign: "center" }}>
                    <ButtonLink
                      text={"EXHIBIT WITH US"}
                      slug={"/trade/exhibit-with-us"}
                      type={"solid"}
                    />
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <ButtonLink
                      text={"PARTICIPATION OPTIONS"}
                      slug={"/trade/participation-options"}
                      type={"solid"}
                    />
                  </div>
                </Grid>
              </div>
            </div>
          </Commendation>

            <div
              style={{
                background: "rgba(250, 250, 250, 1)",
                position: "relative",
                padding: "4rem 0",
              }}
            >
              <div className="constraint">
                <h2
                  style={{
                    textAlign: "center",
                    color: Settings.primaryColor,
                    margin: "0",
                    padding: "1rem 1rem 2rem",
                  }}
                >
                  SHOW HIGHLIGHTS
                </h2>
                <SimpleMasonry
                  data={dataset}
                  off
                  images={[
                    this.props.data.whatsnext.childImageSharp.fluid,
                    this.props.data.maritimeCampus.childImageSharp.fluid,
                    this.props.data.showHighlightsWarship.childImageSharp.fluid,
                    this.props.data.showHighlightsStatic.childImageSharp.fluid,
                    this.props.data.staticDisplays.childImageSharp.fluid,
                  ]}
                  
                />
                
              </div>
            </div>

          <div
            className="constraint"
            style={{ textAlign: "center", padding: "4rem 0 0" }}
          >
            <h2 style={{ color: Settings.primaryColor }}>NEWSBYTE</h2>
            <NewsbyteCluster data={this.props.data.allContentfulNewsbyte} />
          </div>
          <div
            className="constraint"
            style={{
              textAlign: "right",
              fontWeight: "700",
              paddingBottom: "5rem",
            }}
          >
            <Link
              to="/trade/newsbyte"
              style={{ color: Settings.secondaryColor }}
            >
              MORE>
            </Link>
          </div>
          <Partners>
            <div className="constraint">
              <h2>
                {this.props.data.cms
                  ? this.props.data.cms.title
                  : "PARTNERS AND SPONSORS"}
              </h2>
              <Carousel slide={8} fixed>
                {this.props.data.cms.nestedContent.map((logo, i) => {
                  return logo.slug ? (
                    <div>
                      <a href={logo.slug} target="_blank">
                        <Img fluid={logo.image.fluid} />
                      </a>
                    </div>
                  ) : (
                    <div>
                      <Img fluid={logo.image.fluid} />
                    </div>
                  )
                })}
              </Carousel>
            </div>
          </Partners>
          <IndexForm>
            <Grid>
              <div style={{ position: "relative" }}>
                <Img fluid={this.props.data.formBg.childImageSharp.fluid} />
              </div>
              <div className="constraint formElements">
                <h4 style={{ fontSize: "1.1rem" }}>
                  <b>SIGN UP FOR UPDATES</b>
                </h4>
                <FormCluster data={SignUpdates} />
              </div>
            </Grid>
          </IndexForm>
        </Pagewide>
      </Layout>
    )
  }
}

export default TradePage

TradePage.contextType = SiteContext

export const Indexquery = graphql`
  query {
    allContentfulNewsbyte(sort: { fields: [publishedDate], order: DESC }) {
      edges {
        node {
          id
          title
          publishedDate(formatString: "DD MMMM YYYY")
          banner {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
    boxAd: contentfulMedia(id: { eq: "b0c31e74-e60f-5965-8cb8-309da3dc775f" }) {
      id
      advertisements {
        id
        slug
        title
        image {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
      }
      advertisementMobile {
        id
        slug
        title
        image {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
    cms: contentfulPattern(id: { eq: "d51cb173-71f2-5770-9972-c32d37060b7f" }) {
      id
      title
      nestedContent {
        ... on ContentfulPartnersAndSponsors {
          id
          title
          slug
          image {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
    contentfulMedia(id: { eq: "c0a52be5-d873-52a6-a46b-e9387c5d004f" }) {
      id
      advertisements {
        id
        slug
        title
        image {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
      }
      advertisementMobile {
        id
        slug
        title
        image {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
    logoOne: file(relativePath: { eq: "front_logos/1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoTwo: file(relativePath: { eq: "front_logos/2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoThree: file(relativePath: { eq: "front_logos/3.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoFour: file(relativePath: { eq: "front_logos/4.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoFive: file(relativePath: { eq: "front_logos/5.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoSix: file(relativePath: { eq: "front_logos/6.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoSeven: file(relativePath: { eq: "front_logos/7.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoEight: file(relativePath: { eq: "front_logos/8.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoNine: file(relativePath: { eq: "front_logos/9.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoTen: file(relativePath: { eq: "front_logos/10.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoEleven: file(relativePath: { eq: "front_logos/11.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoTwelve: file(relativePath: { eq: "front_logos/12.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoThirteen: file(relativePath: { eq: "front_logos/13.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoFourteen: file(relativePath: { eq: "front_logos/14.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoFifteen: file(relativePath: { eq: "front_logos/15.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoSixteen: file(relativePath: { eq: "front_logos/16.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logoSeventeen: file(relativePath: { eq: "front_logos/17.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    heroImage: file(relativePath: { eq: "masthead.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    fly: file(relativePath: { eq: "fly.png" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    visit: file(relativePath: { eq: "Homepage_WhyVisit.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    exhibit: file(relativePath: { eq: "Homepage_WhyExhibit.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    adspace2: file(relativePath: { eq: "default_ad.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    showHighlightsWarship: file(relativePath: { eq: "staticDisplay.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    showHighlightsStatic: file(relativePath: { eq: "whatsNext.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    whyVisit: file(relativePath: { eq: "Homepage_WhyVisit.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    whyExhibit: file(relativePath: { eq: "Homepage_WhyExhibit.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    whatsnext: file(relativePath: { eq: "businessForums.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    maritimeCampus: file(relativePath: { eq: "inspiring.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    staticDisplays: file(relativePath: { eq: "staticDisplay2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    placead: file(relativePath: { eq: "placead.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bigText: file(relativePath: { eq: "home_bigtext.png" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bg1: file(relativePath: { eq: "dataBottom.png" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bg2: file(relativePath: { eq: "theshow_bg.png" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    formBg: file(relativePath: { eq: "Homepage_Form.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commendation: file(relativePath: { eq: "plane.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
